import { IFittingProps } from '../../../common/ecp-locator-settings';

export interface IEcpLocatorProps extends IFittingProps {
  hasExternalAddress: boolean;
  isResolved: boolean;

}

export enum EcpServices {
  buy = 'buy',
  fit = 'fit',
  cataract = 'cataract',
  cv = 'cv',
  aec = 'aec',
}

export enum BuySortTypes {
  offline = 'offline',
  online = 'online',
}
